export default __webpack_public_path__ + "static/media/backgroundChannel.5d34c718.jpg";